export default __webpack_public_path__ + "static/media/liquidity.66c814d6.svg";